<template>
	<div :id="supplierSelectorRef" :ref="supplierSelectorRef" class="select_items_filter_wrapper">
		<label v-if="showDefaultLabel" for="slectfilter_component_elem" class="d-block">
			{{ label }}
		</label>
		<b-row>
			<b-col :md="!hideAction && !useNewDesign ? 8 : 12" :lg="!hideAction && !useNewDesign ? 8 : 12" :class="`${useNewDesign ? 'd-flex' : ''}`">
				<v-select
					:id="`${useNewDesign ? 'supplier-selector' : ''}`"
					:key="supplierKey"
					v-model="selectedSupplier"
					:placeholder="placeholder"
					:reduce="(option) => option.code"
					:options="mapItems"
					:disabled="disabled"
					:class="{ 'grow-flex-auto': useNewDesign && version === '1.0', 'border-radius-supplier': !hideAction }"
					@input="handleChange"
				>
					<template v-if="showVatNumber" #selected-option-container="{ option }">
						<div class="vs__selected">{{ option.label + ' (' + FormMSG(14, 'TVA : ') + option.vat + ')' }}</div>
					</template>
					<template v-if="version === '2.0'" #selected-option="options">
						<!-- this version doesn't work (about event) -->
						<div class="d-flex align-items-center parent-selected-option">
							<div class="selected-option-label" style="color: rgba(6, 38, 62, 0.84)">{{ options.label }}</div>
							<div v-b-tooltip.hover.top class="cursor-pointer px-1" :title="FormMSG(8, 'Update')" @click.stop.prevent="openEditSupplierModal()">
								<component :is="getLucideIcon('Edit')" color="#225CBD" :size="18" :stroke-width="2.25" />
							</div>
							<div
								v-b-tooltip.hover.top
								class="cursor-pointer px-1"
								:title="FormMSG(9, 'Map')"
								@click.stop.prevent="isMappedSupplierModalOpen = true"
							>
								<component :is="getLucideIcon('Map')" color="rgba(6, 38, 62, 0.5)" :size="18" :stroke-width="2.25" />
							</div>
						</div>
					</template>
				</v-select>
				<div v-if="!hideAction && useNewDesign" class="d-flex flex-row icon-group-border-append">
					<div
						v-if="(version === '1.0' && !isModifiable) || version === '2.0'"
						v-b-tooltip.hover.top
						:style="`width: ${defaultIconWidth}`"
						class="cursor-pointer d-inline-flex justify-content-center align-items-center"
						:title="FormMSG(7, 'Add')"
						@click="openAddSupplierModal()"
					>
						<component :is="getLucideIcon('PlusCircle')" color="#00A09C" :size="18" :stroke-width="2.25" />
					</div>
					<div
						v-else
						v-b-tooltip.hover.top
						:style="`width: ${defaultIconWidth}`"
						class="cursor-pointer d-inline-flex justify-content-center align-items-center"
						:title="FormMSG(8, 'Update')"
						@click="openEditSupplierModal()"
					>
						<component :is="getLucideIcon('Edit')" color="#225CBD" :size="18" :stroke-width="2.25" />
					</div>
					<div
						v-if="version === '1.0' && isModifiable && showMap"
						v-b-tooltip.hover.top
						:style="`width: ${defaultIconWidth}`"
						class="cursor-pointer d-inline-flex justify-content-center align-items-center"
						:title="FormMSG(9, 'Map')"
						@click="isMappedSupplierModalOpen = true"
					>
						<component :is="getLucideIcon('Map')" color="rgba(6, 38, 62, 0.5)" :size="18" :stroke-width="2.25" />
					</div>
				</div>
			</b-col>
			<b-col v-if="!hideAction && !useNewDesign" md="4" lg="4" :class="`${$screen.width <= 992 ? 'mt-2' : ''}`">
				<div class="actions_holder">
					<b-button
						v-if="isModifiable && showMap"
						v-b-tooltip.hover.top
						class="map-btn"
						:disabled="mapDisabled"
						:title="FormMSG(9, 'Map')"
						@click="isMappedSupplierModalOpen = true"
					>
						<component :is="getLucideIcon('Map')" color="#FFF" :size="18" :stroke-width="2" style="margin-left: -4px; margin-top: -3px" />
					</b-button>
					<div class="supplier_actions_btns has_two_btn" :class="`${!isModifiable ? 'w-100' : ''}`">
						<b-button :disabled="disabled" @click="!isModifiable ? openAddSupplierModal() : openEditSupplierModal()">
							<edit v-if="isModifiable" color="#FFFFFF" :size="18" style="margin-top: -3px" />
							<plus-circle v-else color="#FFFFFF" :size="18" style="margin-top: -3px" />
						</b-button>
						<b-button
							block
							variant="outline-primary"
							:disabled="disabled"
							@click="!isModifiable ? openAddSupplierModal() : openEditSupplierModal()"
						>
							{{ !isModifiable ? addlabel : updateLabel }}
						</b-button>
					</div>
				</div>
			</b-col>
		</b-row>
		<SupplierModal
			:key="addressModalKey"
			v-model="isAddressModalOpen"
			:supplier-candidate="supplierCandidate"
			:editable="isModifiable"
			:title="modalTitle"
			:current-search="currSearch"
			:focus-supplier="editSupplierPayload"
			:from-project-config="fromProjectConfig"
			@supplier-name-change="handleSupplierNameChange"
			@submit="handleAddressSubmit"
			@delete-supplier="handleDeleteSupplier"
		/>
		<MappedSuppliersModal
			v-if="!mapDisabled"
			:key="supplierKey"
			v-model="isMappedSupplierModalOpen"
			:selection="selectedSupplier"
			:suppliers="suppliers"
			:placeholder="placeholder"
			@selected="setSelectedSupplier"
		/>
	</div>
</template>

<script>
// import { mapCruds } from "crudx";
import { isNil, omit, makeID, noTilde } from '~utils';
import mapProps from '@/shared/vuePropsMapper';
import { getSupplier, getSuppliers, addSupplier, addAddressSupplier, updateSupplier, deleteSupplier, addUpdSupplierBankAccount } from '@/cruds/suppliers.crud';
import languageMessages from '@/mixins/languageMessages';
import SupplierModal from '@/components/Modals/SupplierModal';
import MappedSuppliersModal from '@/components/Modals/MappedSuppliersModal';
import globalMixin from '@/mixins/global.mixin';
import { PlusCircle, Edit } from 'lucide-vue';
import * as _ from 'lodash';

export default {
	name: 'SupplierSelectorComponent',
	components: { SupplierModal, PlusCircle, Edit, MappedSuppliersModal },
	mixins: [languageMessages, globalMixin],
	props: {
		...mapProps(['disabled', 'mapDisabled', 'hideAction', 'useNewDesign', 'canCrudWithSelect', 'showVatNumber'], {
			type: Boolean,
			required: false,
			default: false
		}),
		...mapProps(['showMap'], {
			type: Boolean,
			required: false,
			default: true
		}),
		fromProjectConfig: {
			type: Boolean,
			default: false,
			required: false
		},
		showMap: {
			type: Boolean,
			default: true,
			required: false
		},
		ocrSuppliers: {
			type: Array,
			required: false,
			default: () => []
		},
		supplierId: {
			type: [Number, String],
			required: false,
			default: 0
		},
		type: {
			type: String,
			required: false,
			default: 'normal'
			// validator: (e) => authorizedType.includes(e),
		},
		placeholder: {
			type: String,
			required: false,
			default: 'Type to search ...'
		},
		label: {
			type: String,
			required: false,
			default: 'Input Name'
		},
		addlabel: {
			type: String,
			required: false,
			default: 'Add'
		},
		updateLabel: {
			type: String,
			required: false,
			default: 'Update'
		},
		showDefaultLabel: {
			type: Boolean,
			required: false,
			default: true
		},
		title: {
			type: String,
			required: false,
			default: 'Add Entity Adress'
		},
		version: {
			type: String,
			required: false,
			default: '1.0' // avalaible version :: 1.0, 2.0 <this version doesn't work properly> (only when useNewDesign=true)
		}
	},
	data() {
		return {
			suppliers: [],
			supplierPayload: {},
			editSupplierPayload: {},
			isModifiable: false,
			selectedSupplier: null,
			currSearch: '',
			supplierCandidate: null,
			isAddressModalOpen: false,
			isEditModalForm: false,
			addressModalKey: makeID(5),
			isMappedSupplierModalOpen: false,
			defaultIconWidth: '34px',
			isLoadingSupplier: false
		};
	},
	computed: {
		/**
		 * @return {String}
		 */
		supplierSelectorRef() {
			return `supplier_selector_${makeID(5)}`;
		},
		modalTitle() {
			return isNil(this.title) ? this.FormMSG(1111, 'Add entity address') : this.title;
		},
		mapItems() {
			let res = this.suppliers.map(({ id, name, contactName, companyType }) => ({
				code: id,
				label: name,
				contactName: contactName,
				companyType: companyType
			}));

			res.sort((a, b) => {
				if (noTilde(a.label.trim()).toLowerCase() < noTilde(b.label.trim()).toLowerCase()) {
					return -1;
				}
				if (noTilde(a.label.trim()).toLowerCase() > noTilde(b.label.trim()).toLowerCase()) {
					return 1;
				}

				return 0;
			});

			const initSupplier = {
				code: null,
				label: this.FormMSG(13, 'Select a supplier'),
				contactName: '',
				companyType: 1
			};

			res = [initSupplier, ...res];

			return res;
		},
		supplierKey() {
			return JSON.stringify(this.suppliers);
		},
		rendSupplierType() {
			//console.log("show supplier type:", this.type);
			const t = isNil(this.type) ? 'normal' : this.type;
			// if (!authorizedType.includes(t)) return null
			switch (t) {
				case 'all':
					return null;
				case 'hotel':
					return 1;
				// break
				case 'electricity':
					return 2;
				// break
				case 'location':
					return 3;
				// break
				case 'owner':
					return 4;
				// break
				case 'licenseOlder':
					return 5;
				case 'client':
					return 6;
				case 'tenant':
					return 7;
				case 'green':
					return 8;
				case 'projectAdmin':
					return 9;
				case 'architect':
					return 10;
				case 'syndic':
					return 11;
				case 'gas':
					return 13;
				case 'water':
					return 14;
				default:
					return 0;
				// break
			}
		}
	},
	watch: {
		/**
		 * @param {Boolean} status
		 */
		isAddressModalOpen(s) {
			this.addressModalKey = makeID(5);
			if (!s) this.handleSupplierModalClose();
		},
		ocrSuppliers(newSuppliers) {
			const vatSuppliers = newSuppliers.filter((d) => d.label === 'VAT').map((d) => d.value);
			const emailSuppliers = newSuppliers.filter((d) => d.label === 'EMAIL').map((d) => d.value);
			// 1st step: looking for matching suppliers by VAT
			const matchingVatSuppliers = this.suppliers.filter((supplier) => vatSuppliers.map((d) => d.vat).indexOf(supplier.vat) > -1);
			const matchingEmailSuppliers = this.suppliers.filter((supplier) => emailSuppliers.indexOf(supplier.email) > -1);
			// handle supplier matching a VAT found in receipt
			if (matchingVatSuppliers.length > 0) {
				const { id, name, vat } = matchingVatSuppliers[0];
				this.setSelectedSupplier({ id, name, vat });
				// if not matching supplier is found using VAT, try with e-mail
			} else if (matchingEmailSuppliers.length > 0) {
				const { id, name, vat } = matchingEmailSuppliers[0];
				this.setSelectedSupplier({ id, name, vat });
				// If no match (neither on VAT nor on email) found, create a supplier based on the VAT number (if any)
			} else if (vatSuppliers.length > 0) {
				const supplierCandidate = vatSuppliers[0];
				const email = emailSuppliers.length > 0 ? emailSuppliers[0] : null;
				supplierCandidate.email = supplierCandidate.email || email || null;
				this.setSupplierCandidate(supplierCandidate);
				this.openAddSupplierModal();
				// If no VAT detected on the ticket
			} else if (emailSuppliers.length > 0) {
				this.setSupplierCandidate({ email: emailSuppliers[0] });
				this.openAddSupplierModal();
			}
		},
		supplierId: {
			handler(n) {
				// console.log('Watch SupplierId: ', n);
				this.initEdit(n);
			},
			deep: true,
			immediate: true
		},

		isLoadingSupplier(newValue) {
			this.$emit('loading-state-changed', newValue);
		}
	},
	async created() {
		await this.initSuppliers();
		// await this.initEdit()
	},
	methods: {
		async handleClickDelete(code) {
			await deleteSupplier({ id: parseInt(code) });
			await this.initSuppliers();
			this.setSelectedSupplier(null);
			this.$emit('supplier:unselected');
		},
		async initSuppliers() {
			this.suppliers = await getSuppliers({
				name: null,
				type: this.rendSupplierType
			});
		},
		async initEdit(supplierId) {
			if (this.isLoadingSupplier) {
				return;
			}

			if (isNil(supplierId) || +supplierId === 0) {
				this.selectedSupplier = null;

				return;
			}

			this.isLoadingSupplier = true;

			await getSupplier(supplierId)
				.then((record) => {
					this.supplierPayload = record;
				})
				.catch((error) => {
					this.supplierPayload = {};
					this.selectedSupplier = null;
				})
				.finally(() => {
					this.isLoadingSupplier = false;
				});

			if (isNil(this.supplierPayload)) return;

			this.setSelectedSupplier({
				id: +supplierId,
				name: this.supplierPayload.name || '',
				legalName: this.supplierPayload.legalName || '',
				email: this.supplierPayload.email || '',
				phone: this.supplierPayload.phone || '',
				contactName: this.supplierPayload.contactName || '',
				companyType: this.supplierPayload.companyType || 1,
				vat: this.supplierPayload.vat || ''
			});
		},
		/**
		 * @param {Object} supplier
		 * @return {Event}
		 */
		emitChange(supplier) {
			if (isNil(supplier)) return;
			this.$emit('change', supplier);
		},
		/**
		 * @param {Object} supplier
		 */
		setSelectedSupplier(supplier) {
			if (isNil(supplier) || +supplier.id === 0) {
				this.selectedSupplier = null;
				// this.emitChange(null);
				this.isModifiable = false;
			} else {
				const { name, id, email, phone, contactName, companyType, vat } = supplier;
				this.currSearch = name;
				this.emitChange({ id, name, email, phone, contactName, companyType });
				this.selectedSupplier = {
					code: id,
					label: name,
					email,
					phone,
					vat
				};
				this.isModifiable = true;
			}
		},
		/**
		 * @param {Object} $event
		 */
		async handleChange(payload) {
			this.selectedSupplier = null;
			if (!_.isNil(payload) && +payload > 0) {
				this.isModifiable = true;
				await getSupplier(+payload)
					.then((record) => {
						this.supplierPayload = record;
					})
					.catch((error) => {
						this.supplierPayload = {};
						this.selectedSupplier = null;
					});
				// console.log({supplierPayload: this.supplierPayload})
				this.setSelectedSupplier({
					id: +payload,
					name: this.supplierPayload.name || '',
					legalName: this.supplierPayload.legalName || '',
					email: this.supplierPayload.email || '',
					phone: this.supplierPayload.phone || '',
					contactName: this.supplierPayload.contactName,
					companyType: this.supplierPayload.companyType,
					vat: this.supplierPayload.vat || ''
				});
			} else {
				this.isModifiable = false;
				this.selectedSupplier = null;
				this.$emit('supplier:unselected');
			}
			// if (isNil(code)) return;
			this.currSearch = '';
		},
		/**
		 * @param {String} search
		 */
		handleSearch(search) {
			if (search === '') return;
			this.currSearch = search;
			this.$emit('search', search);
		},
		/**
		 * @param {String} name
		 */
		handleSupplierNameChange(name) {
			if (isNil(name)) return;
			this.supplierPayload.name = name;
		},
		/**
		 * @param {Object} supplier
		 */
		setSupplierCandidate(supplier) {
			this.supplierCandidate = supplier;
		},
		// ADDRESS
		openAddSupplierModal() {
			this.editSupplierPayload = {};
			this.$set(this.editSupplierPayload, 'companyType', 0);
			this.supplierPayload = {};
			this.$set(this.supplierPayload, 'companyType', 0);
			this.isModifiable = false;
			this.isEditModalForm = false;
			const hasSearch = this.currSearch !== '';
			if (hasSearch) this.supplierPayload.name = this.currSearch;

			this.isAddressModalOpen = true;
		},
		async openEditSupplierModal() {
			if (isNil(this.selectedSupplier)) return;
			const { code } = this.selectedSupplier;
			await getSupplier(code)
				.then((record) => {
					this.supplierPayload = this.editSupplierPayload = record;
				})
				.catch((error) => {
					this.supplierPayload = {};
					this.selectedSupplier = null;
				});
			this.isEditModalForm = true;
			this.isAddressModalOpen = true;
			this.isModifiable = true;
		},
		handleSupplierModalClose() {
			this.editSupplierPayload = {};
			this.supplierPayload.name = '';
		},
		/**
		 * @param {Number} id - supplierID
		 */
		async handleDeleteSupplier(id) {
			// const { id } = this.editSupplierPayload;
			this.editSupplierPayload = {};
			this.emitChange({ id: 0, name: '', email: '', phone: '', contactName: '', companyType: 1 });
			await deleteSupplier(id);
			await this.initSuppliers();
			this.setSelectedSupplier(null);
			this.isAddressModalOpen = false;
		},
		/**
		 * @param {Object} address
		 */
		async handleAddressSubmit(supplier) {
			let required = false;
			if (isNil(supplier.name) || supplier.name.trim() === '') {
				this.createToastForMobile(this.FormMSG(5, 'Error'), this.FormMSG(4, 'Name is required'), '', 'danger');

				required = true;
			} else if (
				isNil(supplier.address) ||
				(!isNil(supplier.address) &&
					(!('city' in supplier.address) || !('zip' in supplier.address) || !('street' in supplier.address) || !('number' in supplier.address)))
			) {
				this.createToastForMobile(this.FormMSG(5, 'Error'), this.FormMSG(6, 'Address is required'), '', 'danger');

				required = true;
			}
			if (required) return;

			if (this.isEditModalForm) {
				await updateSupplier({
					id: supplier.id,
					supplier: omit(['address'], supplier),
					address: supplier.address
				});

				await this.initSuppliers();
				this.setSelectedSupplier({
					id: parseInt(supplier.id),
					name: supplier.name,
					legalName: supplier.legalName,
					vat: supplier.vat || ''
				});

				await this.manageBankAction(+supplier.id, supplier.banks);

				this.createToastForMobile(this.FormMSG(10, 'Success'), this.FormMSG(11, 'Supplier updated successfully'), '', 'success');
			} else {
				const { id, name, vat } = await addSupplier({
					name: supplier.name || '',
					type: this.rendSupplierType
				});

				this.supplierPayload.name = name;
				await addAddressSupplier({
					id,
					supplier: omit(['address'], supplier),
					address: supplier.address
				});
				await this.initSuppliers();
				this.supplierPayload = {
					...supplier,
					id,
					name,
					vat
				};
				await this.setSelectedSupplier({ id: parseInt(id), name, vat });

				await this.manageBankAction(+id, supplier.banks);

				this.createToastForMobile(this.FormMSG(10, 'Success'), this.FormMSG(12, 'Supplier added successfully'), '', 'success');
			}

			this.clearEditMode();
		},
		clearEditMode() {
			this.editSupplierPayload = {};
			this.supplierPayload = {};
			this.isEditModalForm = false;
		},
		async manageBankAction(supplierId, banks) {
			for (const bank of banks) {
				await addUpdSupplierBankAccount(+bank.id, {
					supplierId,
					...bank
				}).catch((error) => {
					console.error({ error });
				});
			}
		}
	}
};
</script>
<style lang="scss" scoped>
.actions_holder {
	width: 100%;
	display: flex;
	justify-content: center;
	align-items: center;

	button.map-btn {
		width: 32px;
		height: 32px;
		border-radius: 16px;
		margin-right: 12px;
		text-align: center;
	}
	.supplier_actions_btns {
		width: calc(100% - 40px);
	}
}
</style>
